import type { TranslationTag } from '@ps/web-core-intl';
import React from 'react';
import { useForm } from 'react-final-form';

import type {
  OptionToggle,
  OptionToggleClasses,
  TOnChange
} from '../MultipleSelectToggle/MultipleSelectToggle';
import MultipleSelectToggle from '../MultipleSelectToggle/MultipleSelectToggle';

interface GroupToggleClasses extends OptionToggleClasses {
  toggleGroup: string;
}

interface StyleProps {
  classes?: GroupToggleClasses;
}

export interface MultipleSelectGroupToggleProps extends StyleProps {
  id: string;
  label: TranslationTag;
  options: OptionToggle[];
  onChange?: TOnChange;
}

const MultipleSelectGroupToggle: React.FC<MultipleSelectGroupToggleProps> = ({
  id,
  label,
  options,
  classes,
  onChange
}) => {
  const form = useForm();

  const handleGroupToggleChanged: TOnChange = (_, checked) => {
    form.batch(() => {
      options.forEach((option) => form.change(option.id, checked));
    });
    onChange?.(options, checked);
  };

  const handleToggleChanged: TOnChange = (changedOptions, checked) => {
    const { values } = form.getState();
    const allChecked = options.every((option) => values[option.id]);

    form.change(id, allChecked);
    onChange?.(changedOptions, checked);
  };

  return (
    <div className={classes?.toggleGroup}>
      <MultipleSelectToggle
        id={id}
        label={label}
        value=""
        classes={classes}
        onChange={handleGroupToggleChanged}
      />
      {options?.map((option) => (
        <MultipleSelectToggle
          id={option.id}
          key={option.id}
          label={option.label}
          value={option.value}
          classes={classes}
          onChange={handleToggleChanged}
        />
      ))}
    </div>
  );
};

export default MultipleSelectGroupToggle;
